/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  GetVendorsParams,
  HTTPValidationError,
  PageVendorManyRead,
  VendorCreate,
  VendorRead,
} from "./fastAPI.schemas";

import { customInstance } from "../../axios";
import type { ErrorType } from "../../axios";

/**
 * Route to create a new vendor.
 * @summary Create Vendor
 */
export const createVendor = (
  vendorCreate: VendorCreate,
  signal?: AbortSignal,
) => {
  return customInstance<number>({
    url: `/api/vendor/`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: vendorCreate,
    signal,
  });
};

export const getCreateVendorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createVendor>>,
    TError,
    { data: VendorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createVendor>>,
  TError,
  { data: VendorCreate },
  TContext
> => {
  const mutationKey = ["createVendor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createVendor>>,
    { data: VendorCreate }
  > = (props) => {
    const { data } = props ?? {};

    return createVendor(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof createVendor>>
>;
export type CreateVendorMutationBody = VendorCreate;
export type CreateVendorMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Create Vendor
 */
export const useCreateVendor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createVendor>>,
      TError,
      { data: VendorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof createVendor>>,
  TError,
  { data: VendorCreate },
  TContext
> => {
  const mutationOptions = getCreateVendorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * Route to get many vendors.

Results are paginated.
 * @summary Get Vendors
 */
export const getVendors = (params?: GetVendorsParams, signal?: AbortSignal) => {
  return customInstance<PageVendorManyRead>({
    url: `/api/vendor/`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetVendorsInfiniteQueryKey = (params?: GetVendorsParams) => {
  return ["infinite", "api", "vendor", ...(params ? [params] : [])] as const;
};

export const getGetVendorsQueryKey = (params?: GetVendorsParams) => {
  return ["api", "vendor", ...(params ? [params] : [])] as const;
};

export const getGetVendorsInfiniteQueryOptions = <
  TData = InfiniteData<
    Awaited<ReturnType<typeof getVendors>>,
    GetVendorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getVendors>>,
        TError,
        TData,
        QueryKey,
        GetVendorsParams["page"]
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetVendorsInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getVendors>>,
    QueryKey,
    GetVendorsParams["page"]
  > = ({ signal, pageParam }) =>
    getVendors({ ...params, page: pageParam || params?.["page"] }, signal);

  return { queryKey, queryFn, ...queryOptions } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getVendors>>,
    TError,
    TData,
    QueryKey,
    GetVendorsParams["page"]
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVendorsInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVendors>>
>;
export type GetVendorsInfiniteQueryError =
  ErrorType<void | HTTPValidationError>;

export function useGetVendorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getVendors>>,
    GetVendorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetVendorsParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getVendors>>,
        TError,
        TData,
        QueryKey,
        GetVendorsParams["page"]
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendors>>,
          TError,
          Awaited<ReturnType<typeof getVendors>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getVendors>>,
    GetVendorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getVendors>>,
        TError,
        TData,
        QueryKey,
        GetVendorsParams["page"]
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendors>>,
          TError,
          Awaited<ReturnType<typeof getVendors>>,
          QueryKey
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getVendors>>,
    GetVendorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getVendors>>,
        TError,
        TData,
        QueryKey,
        GetVendorsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Vendors
 */

export function useGetVendorsInfinite<
  TData = InfiniteData<
    Awaited<ReturnType<typeof getVendors>>,
    GetVendorsParams["page"]
  >,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getVendors>>,
        TError,
        TData,
        QueryKey,
        GetVendorsParams["page"]
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVendorsInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetVendorsQueryOptions = <
  TData = Awaited<ReturnType<typeof getVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendors>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVendorsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendors>>> = ({
    signal,
  }) => getVendors(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getVendors>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetVendorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVendors>>
>;
export type GetVendorsQueryError = ErrorType<void | HTTPValidationError>;

export function useGetVendors<
  TData = Awaited<ReturnType<typeof getVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params: undefined | GetVendorsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendors>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendors>>,
          TError,
          Awaited<ReturnType<typeof getVendors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendors<
  TData = Awaited<ReturnType<typeof getVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendors>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendors>>,
          TError,
          Awaited<ReturnType<typeof getVendors>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendors<
  TData = Awaited<ReturnType<typeof getVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Vendors
 */

export function useGetVendors<
  TData = Awaited<ReturnType<typeof getVendors>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  params?: GetVendorsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendors>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVendorsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to get an vendor by ID.
 * @summary Get Vendor
 */
export const getVendor = (vendorId: number, signal?: AbortSignal) => {
  return customInstance<VendorRead>({
    url: `/api/vendor/${vendorId}`,
    method: "GET",
    signal,
  });
};

export const getGetVendorQueryKey = (vendorId?: number) => {
  return ["api", "vendor", vendorId] as const;
};

export const getGetVendorQueryOptions = <
  TData = Awaited<ReturnType<typeof getVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  vendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetVendorQueryKey(vendorId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getVendor>>> = ({
    signal,
  }) => getVendor(vendorId, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!vendorId,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetVendorQueryResult = NonNullable<
  Awaited<ReturnType<typeof getVendor>>
>;
export type GetVendorQueryError = ErrorType<void | HTTPValidationError>;

export function useGetVendor<
  TData = Awaited<ReturnType<typeof getVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  vendorId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendor>>,
          TError,
          Awaited<ReturnType<typeof getVendor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendor<
  TData = Awaited<ReturnType<typeof getVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  vendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVendor>>,
          TError,
          Awaited<ReturnType<typeof getVendor>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetVendor<
  TData = Awaited<ReturnType<typeof getVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  vendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get Vendor
 */

export function useGetVendor<
  TData = Awaited<ReturnType<typeof getVendor>>,
  TError = ErrorType<void | HTTPValidationError>,
>(
  vendorId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getVendor>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetVendorQueryOptions(vendorId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Route to update an vendor by ID.
 * @summary Update Vendor
 */
export const updateVendor = (vendorId: number, vendorCreate: VendorCreate) => {
  return customInstance<number>({
    url: `/api/vendor/${vendorId}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: vendorCreate,
  });
};

export const getUpdateVendorMutationOptions = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateVendor>>,
    TError,
    { vendorId: number; data: VendorCreate },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateVendor>>,
  TError,
  { vendorId: number; data: VendorCreate },
  TContext
> => {
  const mutationKey = ["updateVendor"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateVendor>>,
    { vendorId: number; data: VendorCreate }
  > = (props) => {
    const { vendorId, data } = props ?? {};

    return updateVendor(vendorId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateVendorMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateVendor>>
>;
export type UpdateVendorMutationBody = VendorCreate;
export type UpdateVendorMutationError = ErrorType<void | HTTPValidationError>;

/**
 * @summary Update Vendor
 */
export const useUpdateVendor = <
  TError = ErrorType<void | HTTPValidationError>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateVendor>>,
      TError,
      { vendorId: number; data: VendorCreate },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof updateVendor>>,
  TError,
  { vendorId: number; data: VendorCreate },
  TContext
> => {
  const mutationOptions = getUpdateVendorMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
